module.exports = __webpack_public_path__ + "static/media/wn_logo.1a2d65f1.svg";